import { useQuery } from '@tanstack/react-query';
import UserPermissionsService from '../../services/user-permissions';

export const USER_STUDIO_ACCESS_QUERY_KEY = ['UserStudioAccess'];

export const useUserStudioAccessQuery = () => {
  return useQuery<boolean, Error>({
    queryKey: USER_STUDIO_ACCESS_QUERY_KEY,
    queryFn: async () => {
      const service = new UserPermissionsService();
      const response = await service.getStudioAccess();
      return response.data.studio_access ?? false;
    },
    meta: { persist: false },
  });
};
